<div style="background-color: #c8c8c8; height: 100%" fxLayout="row" fxLayoutAlign="center start">
  <mat-card style="max-width: 450px; margin-top: 10px">
    <mat-card-title>{{ 'NO_ACCESS' | translate }}</mat-card-title>
    <mat-card-content>{{ 'NO_ACCESS_APPLICATION' | translate }}</mat-card-content>
    <mat-card-actions align="end">
      <spx-button [color]="'primary'" [type]="'mat-button'" (click)="logout()">
        {{ 'LOGOUT' | translate }}
      </spx-button>
    </mat-card-actions>
  </mat-card>
</div>
